import React, { useContext } from 'react';

import { EntityContext } from 'context/entityContext';
import useMedia from 'hooks/useMedia';

import MobileNav from 'components/TopicNavigation/MobileNav';
import DesktopNav from 'components/TopicNavigation/DesktopNav';

/*
 * Navigation in Opus consists of the `TopicNavigation` and the complementary `SubNavigation`,
 * the latter is placed at topic level (such as `pages/Artist/Overview/index`).
 *
 * ##Mobile
 * Shows a dropdown with a list. The list consists of links or other dropdowns.
 * If the user is on a sub-topic (such as performance/streaming), the dropdown
 * containing that link is opened automatically.
 *
 * ## Desktop
 * Shows a horizontal list with links and dropdowns.
 * Hovering over a dropdown for 200ms shows the open state. The open state consists
 * of vertical lists aligned their corresponding dropdown.
 *
 */

interface ITopicNavigationProps {
  pathPrefix: string;
  activeTopic: string;
}
const TopicNavigation: React.FC<ITopicNavigationProps> = (props) => {
  const { pathPrefix, activeTopic } = props;

  const ctx = useContext(EntityContext);
  const isLargeScreen = useMedia('(min-width: 50em)');

  const { entityType, parentEntityId, entityIds, compareMode } = ctx;
  const entities = entityIds.join(',');

  const Navigation = isLargeScreen ? DesktopNav : MobileNav;

  function getTopicUrl(topic: any): string {
    if (parentEntityId && !compareMode) {
      return `${pathPrefix}/${entityType}/${parentEntityId}/version/${entities}/${topic}`;
    }
    return `${pathPrefix}/${entityType}/${entities}/${topic}`;
  }

  return <Navigation activeTopic={activeTopic} getTopicUrl={getTopicUrl} />;
};

export default TopicNavigation;
